/*
=========================================================
 * Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import { useTranslation } from "react-i18next";

function Counters() {
  const { t } = useTranslation();
  return (
    <MKBox component="section" pt={2} pb={4}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={150}
              suffix="+"
              title={t("Bankruptcies")}
              description={t("BankruptciesDescription")}
            />
          </Grid>
          <Grid item xs={12} md={3} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={45}
              suffix="+"
              title={t("LivingTrusts")}
              description={t("LivingTrustsDescription")}
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={18}
              suffix="+"
              title={t("Refinancing")}
              description={t("RefinancingDescription")}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={90}
              title={t("BuySellProperties")}
              description={t("BuySellPropertiesDescription")}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
